import { useApiFastOrderBrands } from '@hooks-api/fortune/use-api-fast-order-brands'
import { useMemo } from 'react'
import { useStmMallCode } from '../../hooks/use-stm-mall-code'
import { type FastOrderBrandDto } from '../dtos/fast-order-brand-dto'
import { toFastOrderBrandDtos } from '../utils/fast-order-brand-transformer'

export const useFastOrderBrands = () => {
  const mallCode = useStmMallCode()
  const { destructuredData: brands, isLoading, error } = useApiFastOrderBrands({ mall_code: mallCode })
  const fastOrderBrands = useMemo<FastOrderBrandDto[]>(() => toFastOrderBrandDtos(brands ?? []), [brands])

  return { fastOrderBrands, isLoading, error }
}
